import "./auth-service-tools177.js";
import { createContext } from "react";
const DATES_PROVIDER_DEFAULT_SETTINGS = {
  locale: "en",
  timezone: null,
  firstDayOfWeek: 1,
  weekendDays: [0, 6],
  labelSeparator: "–",
  consistentWeeks: false
};
const DatesProviderContext = /*#__PURE__*/createContext(DATES_PROVIDER_DEFAULT_SETTINGS);
export { DATES_PROVIDER_DEFAULT_SETTINGS, DatesProviderContext };